import { useCallback } from 'react';
import { useAppSelector } from 'store';
import { generalSliceSelectors } from 'store/slices/general/config';
import { translate } from 'common/helpers/translate';
import { usersSelectors } from 'store/slices/users/config';
import type { LanguageType } from 'common/constants';

export interface TranslationReplacer {
  key: string;
  value: string;
}
type UseTranslations = {
  t: (key: string, replacers?: Array<TranslationReplacer>) => string;
  language: LanguageType;
};
export const useTranslations = (): UseTranslations => {
  const profile = useAppSelector(usersSelectors.selectProfile);
  const temporaryLanguage = useAppSelector(
    generalSliceSelectors.selectTemporaryLanguage,
  );
  const translations = useAppSelector(
    generalSliceSelectors.selectAllTranslations,
  );

  const savedLanguage = profile?.language;
  const translationLanguage =
    temporaryLanguage !== savedLanguage ? temporaryLanguage : savedLanguage;
  const t = useCallback(
    (key: string, replacers?: Array<TranslationReplacer>) => {
      let translated = translate(
        translations,
        key,
        (translationLanguage || '').toLowerCase(),
      );
      if (replacers && Array.isArray(replacers) && replacers.length > 0) {
        replacers.forEach((replacer) => {
          translated = translated.replace(
            `{${replacer.key}}`,
            String(replacer.value),
          );
        });
      }
      return translated;
    },
    [translationLanguage, translations],
  );

  return {
    t,
    language: translationLanguage,
  };
};
